import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { getCategoryAdditionalParameters } from '../api/queries';

export interface AdditionalParameter {
  id: string;
  name: string;
  iconUrl?: string | null;
}

export const useCategoryAdditionalParameters = (categoryId?: string) => {
  const { data, loading } = useQuery(getCategoryAdditionalParameters, {
    variables: { categoryId: categoryId ?? '' },
    skip: !categoryId,
    errorPolicy: 'all'
  });

  const parameters = useMemo<AdditionalParameter[]>(
    () => data?.additionalParameters ?? [],
    [data]
  );

  return { parameters, loading };
};
